import React, { Fragment, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';
const Countries = () => {
  const countryLinks = useSelector((state) => state.navigation.countryLinks);
  const firstRender = useRef(true);
  const countryList = useRef(null);
  useEffect(() => {
    if (!firstRender.current) {
      return;
    }
    firstRender.current = false;
  }, [countryLinks]);
  return (
    <Fragment>
      <div className="countrydetail">
        <span
          onClick={(e) =>
            countryList.current.classList.toggle(
              'countrydetail__select-list--open'
            )
          }
          className="countrydetail__select"
        >
          {translate('header.marketselect')}
        </span>
        {countryLinks.length > 0 && (
          <ul className="countrydetail__select-list" ref={countryList}>
            {countryLinks.map(({ text, url, imageUrl }, index) => (
              <li
                className="countrydetail__select-list-item"
                key={`country-${index}`}
              >
                <a className="countrydetail__select--list-item-link" href={url}>
                  {text}
                </a>
                <img
                  className="countrydetail__select-list-item-image"
                  src={imageUrl}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </Fragment>
  );
};
export default Countries;
